/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtaben4Inputs */

const en_letterpreviewtaben4 = /** @type {(inputs: Letterpreviewtaben4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English (your reference)`)
};

const pt_letterpreviewtaben4 = /** @type {(inputs: Letterpreviewtaben4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês (sua referência)`)
};

/**
* | output |
* | --- |
* | "English (your reference)" |
*
* @param {Letterpreviewtaben4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtaben4 = /** @type {((inputs?: Letterpreviewtaben4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtaben4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtaben4(inputs)
	return pt_letterpreviewtaben4(inputs)
});
export { letterpreviewtaben4 as "letterPreviewTabEN" }